import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews, IconReviewStar } from '../../components';
import { fakeRatingData } from '../../util/ratingHelpers';
import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError, listing, customReview } = props;

  const fakeRatings = fakeRatingData(listing);

  return (
    <div className={css.sectionReviews}>
      <Heading as="h3" rootClassName={css.sectionHeadingWithExtraMargin}>
        <div className={css.reviewContainer}>
          <FormattedMessage id="ListingPage.reviewsTitle" />
          {!!fakeRatings?.totalRating && (
            <div className={css.rating}>
              <IconReviewStar className={css.star} isFilled />
              <span>{fakeRatings?.totalRating.toFixed(1)}</span>
            </div>
          )}
          {/* {fakeRatings?.totalBookings && (
            <div>
              ({fakeRatings?.totalBookings} <FormattedMessage id="ListingPage.bookings" />)
            </div>
          )} */}
        </div>
      </Heading>
      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}
      <Reviews reviews={reviews} customReview={customReview} />
    </div>
  );
};

export default SectionReviews;
